import React, { useState } from "react"
import {
  AuthTypeSelect,
  AuthTypeWrapper,
  Border,
  Grid,
  Info
} from "../../../views/Settings/ExternalEvents/DestinationAPIs/Shared.styled"
import Input from "../../Ui/Form/Input"
import { UseFormRegister } from "react-hook-form"
import { ApiDestinationUpdateInputs } from "lib/types/externalEvents"
import { FieldErrors } from "react-hook-form/dist/types/errors"
import { UseFormSetValue } from "react-hook-form/dist/types/form"

enum AuthType {
  API_KEY_AUTH,
  BASIC_AUTH
}

type Props = {
  register: UseFormRegister<ApiDestinationUpdateInputs>
  errors: FieldErrors
  setValue: UseFormSetValue<ApiDestinationUpdateInputs>
}

const Authentication = ({ register, errors, setValue }: Props) => {
  const [authType, setAuthType] = useState<AuthType>(AuthType.BASIC_AUTH)

  const setBasicAuth = () => {
    setAuthType(AuthType.BASIC_AUTH)
    setValue("options.apiKeyAuth", undefined)
  }

  const setApiKeyAuth = () => {
    setAuthType(AuthType.API_KEY_AUTH)
    setValue("options.basicAuth", undefined)
  }

  return (
    <div>
      <AuthTypeWrapper>
        <Border>
          <AuthTypeSelect
            $selected={authType === AuthType.BASIC_AUTH}
            onClick={setBasicAuth}
          >
            Basic Auth
          </AuthTypeSelect>
          <AuthTypeSelect
            $selected={authType === AuthType.API_KEY_AUTH}
            onClick={setApiKeyAuth}
          >
            API key auth
          </AuthTypeSelect>
        </Border>
      </AuthTypeWrapper>
      {authType === AuthType.BASIC_AUTH && (
        <>
          <Info>Enter user and password for basic auth.</Info>
          <Grid>
            <Input
              name="options.basicAuth.user"
              label="User: *"
              register={register}
              validation={{
                required: "User is required",
                minLength: 1,
                maxLength: 512
              }}
              errors={errors}
            />
            <Input
              name="options.basicAuth.password"
              label="Password: *"
              register={register}
              validation={{
                required: "User is required",
                minLength: 1,
                maxLength: 512
              }}
              errors={errors}
            />
          </Grid>
        </>
      )}
      {authType === AuthType.API_KEY_AUTH && (
        <>
          <Info>Enter an API key to include in the header for each authentication request.</Info>
          <Grid>
            <Input
              name="options.apiKeyAuth.name"
              label="Name: *"
              register={register}
              validation={{
                minLength: 1,
                maxLength: 512
              }}
              errors={errors}
            />
            <Input
              name="options.apiKeyAuth.key"
              label="API key: *"
              register={register}
              validation={{
                minLength: 1,
                maxLength: 512
              }}
              errors={errors}
            />
          </Grid>
        </>
      )}
    </div>
  )
}

export default Authentication
